import React from 'react';
import { LoadingPlaceholder, TextBlock } from '@thd-olt-component-react/loading-placeholder';
import Loading from './index';

const ConfigLoader = () => {
  return (
    <div style={{ padding: 20 }}>
      <LoadingPlaceholder
        ready={false}
        type="rect"
        showLoadingAnimation
        color="#E0E0E0"
        style={{
          height: '170px',
          width: '100%',
        }}
      >
        <span style={{ width: '100%' }} />
      </LoadingPlaceholder>
      <LoadingPlaceholder
        ready={false}
        type="rect"
        showLoadingAnimation
        color="#E0E0E0"
        style={{
          height: '40px',
          width: '100%',
          marginTop: '40px',
          marginBottom: '20px',
        }}
      >
        <span style={{ width: '100%' }} />
      </LoadingPlaceholder>
      <TextBlock rows={3} color="#E0E0E0" />
      <LoadingPlaceholder
        ready={false}
        type="rect"
        showLoadingAnimation
        color="#E0E0E0"
        style={{
          height: '40px',
          width: '100%',
          marginTop: '60px',
          marginBottom: '20px',
        }}
      >
        <span style={{ width: '100%' }} />
      </LoadingPlaceholder>
      <TextBlock rows={20} color="#E0E0E0" />
    </div>
  );
};

export default ConfigLoader;
